// extracted by mini-css-extract-plugin
export default {"Container":"Whitepaper_Container__MWHoU","Header":"Whitepaper_Header__XBzuK","Img":"Whitepaper_Img__QLyKD"};